import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getNotification = state =>
  getStateSlice(state).get('notification');

export const getIsOpen = state => getStateSlice(state).get('isOpen');
